import AScene from "../../library/ExtendedObjects/AScene.js";
import Utils from "../../library/Utils.js";

export default class Header
{
    /**
     * @param {AScene} scene 
     */
    constructor(scene)
    {
        this.scene = scene;

        this.headerBg = this.scene.addImage(this.scene.mid.x, 52, "UIBar");
        this.headerBg.displayWidth = this.scene.size.width + 1;
        this.howToPlay = this.scene.addText(this.scene.mid.x, 44, "How to Play", 50, null, 'center', null, 'comfortaa_b');

        this.currentQuestion = 0;
        this.dots = [];

        this.fillColor = 0xffb91d;
        this.emptyColor = 0xc90022;
        
        let numQuestions = 6;
        let spacing = 32;
        for(let i = 0; i < numQuestions; i++)
        {
            this.dots.push(this.scene.addImage(this.scene.size.width - 190 + (spacing * i), 45, "dot"));
            this.dots[i].tint = this.emptyColor;
        }
        this.idiomNumber = this.scene.addText(this.scene.mid.x, 44, "Idiom Number", 50, null, 'center', null, 'comfortaa_b');
        this.menuButton = this.scene.addButton(100, 45, "MenuBtn", {tintOnDown: 0xaaaaaa}, ()=>{
            Utils.TransitionScenes(this.scene, "Intro", 1000, 0, -1);
        });

        this.mainGroup = this.scene.add.container(this.scene.size.width, 0, this.dots);
        this.mainGroup.add(this.idiomNumber);
        this.mainGroup.add(this.menuButton);

        this.idiomText = "Idiom #";
    }

    destroy()
    {
        this.headerBg.destroy();
        this.mainGroup.destroy();
    }

    incrementProgress()
    {
        this.dots[this.currentQuestion].tint = this.fillColor;
        this.currentQuestion++;
        this.idiomNumber.text = this.idiomText + this.currentQuestion.toString();

        this.scene.addTween(this.mainGroup, 500, {x: 0}, Phaser.Math.Easing.Sine.Out);
        this.scene.addTween(this.howToPlay, 500, {x: -this.scene.size.width}, Phaser.Math.Easing.Sine.Out);
    }

    beginReviewState()
    {
        this.currentQuestion = 0;
        this.fillColor = 0x46ff75; 
        this.emptyColor = 0x408666;
        for(let i = 1; i < this.dots.length; i++)
        {
            this.dots[i].tint = this.emptyColor;
        }
        this.dots[0].tint = this.fillColor;

        this.scene.addTween(this.headerBg, 500, {y: -107}, Phaser.Math.Easing.Sine.Out, ()=>{
            this.idiomText = "Review #";
            this.idiomNumber.text = this.idiomText + this.currentQuestion.toString();
            this.headerBg.setFrame("UIBar_2", false, false);
            this.scene.addTween(this.headerBg, 500, {y: 53}, Phaser.Math.Easing.Sine.Out);
        });
        this.scene.addTween(this.mainGroup, 500, {y: -107}, Phaser.Math.Easing.Sine.Out, ()=>{
            this.scene.addTween(this.mainGroup, 500, {y: 0}, Phaser.Math.Easing.Sine.Out);
        });
        
    }
}